import * as THREE from 'three';

export const CAMERA_POSITIONS = {
  home: {
    position: new THREE.Vector3(-1.2, 1.8, 2.8),
    target: new THREE.Vector3(0, 0.8, 0)
  },
  work: {
    position: new THREE.Vector3(0, 2.2, 3.5),
    target: new THREE.Vector3(0, 0.9, 0)
  },
  media: {
    position: new THREE.Vector3(0, 2.6, 3.9),
    target: new THREE.Vector3(0, 0.9, 0)
  },
  contact: {
    position: new THREE.Vector3(0, 2.9, 4.2),
    target: new THREE.Vector3(0, 0.9, 0)
  },
  about: {
    position: new THREE.Vector3(0, 2.8, 4),
    target: new THREE.Vector3(0, 0.9, 0)
  }
};

export const DEFAULT_BACKGROUND_COLOR = 0x080a10;
export const DAY_BACKGROUND_COLOR = 0x1a1d21;
export const NIGHT_BACKGROUND_COLOR = 0x080a10; 